// extracted by mini-css-extract-plugin
export default {"textComparisonParentClassWhenshowMetaDataForTextComparisonModelScenario":"ViewAndTrimAudioResource_textComparisonParentClassWhenshowMetaDataForTextComparisonModelScenario__2n5r-"};